package com.nonopn.skywatcher.design.theme

import androidx.compose.ui.unit.TextUnit
import androidx.compose.ui.unit.sp
import eu.codlab.platform.Platform
import eu.codlab.platform.currentPlatform

data class FontSizes(
    val menu: MenuSize = MenuSize(),
    val popup: PopupSize = PopupSize(),
    val actionBar: ActionBar = ActionBar(),
    val administrators: AdministratorsSizes = AdministratorsSizes(),
    val map: Map = Map(),
    val weatherColumn: WeatherColumn = WeatherColumn(),
    val estimates: EstimateFontSize = EstimateFontSize()
)

data class EstimateFontSize(
    val discount: TextUnit = 16.sp,
    val price: TextUnit = 22.sp,
)

data class WeatherColumn(
    val hourSectionTitle: TextUnit = 22.sp,
    val dateSectionTitle: TextUnit = 18.sp,
    val disclaimer: TextUnit = 12.sp,
    val conditionTitle: TextUnit = 22.sp,
    val conditionText: TextUnit = 16.sp,
    val indexTitleBeforeCard: TextUnit = 16.sp,
    val indexTextInsideCard: TextUnit = 12.sp,
    val infoMainNow: TextUnit = 16.sp,
    val infoMainLater: TextUnit = 14.sp
)

data class MenuSize(
    val title: TextUnit = 14.sp,
    val item: TextUnit = 14.sp,
    val switch: TextUnit = 12.sp
)

data class AdministratorsSizes(
    val cardUserEmail: TextUnit = 14.sp,
    val cardUserUuid: TextUnit = 10.sp,
)

data class PopupSize(
    val title: TextUnit = 24.sp,
    val text: TextUnit = 16.sp,
    val button: TextUnit = 14.sp
)

data class ActionBar(
    val title: TextUnit = TextUnit.Unspecified
)

data class Map(
    val activityLightning: TextUnit = 12.sp,
    val alertBannerSub: TextUnit = 18.sp,
    val alertBannerETA: TextUnit = 28.sp,
    val alertBannerTitle: TextUnit = 24.sp,
    val callOutBig: TextUnit = 22.sp,
    val callOutNormal: TextUnit = 12.sp,
    val ngText: TextUnit = 16.sp,
)

private val defaultFontSizes = FontSizes()

private val jvmFontSizes = FontSizes(
    menu = MenuSize(
        title = 12.sp,
        item = 12.sp,
        switch = 10.sp,
    ),
    popup = PopupSize(
        title = 20.sp,
        text = 16.sp,
        button = 12.sp
    ),
    actionBar = ActionBar(
        title = 18.sp
    ),
    administrators = AdministratorsSizes(
        cardUserEmail = 12.sp,
        cardUserUuid = 8.sp,
    ),
    map = Map(
        activityLightning = 10.sp,
        alertBannerSub = 14.sp,
        alertBannerETA = 24.sp,
        alertBannerTitle = 18.sp,
        callOutBig = 18.sp,
        callOutNormal = 10.sp,
        ngText = 12.sp,
    ),
    estimates = EstimateFontSize(
        price = 18.sp,
        discount = 14.sp,
    ),
    weatherColumn = WeatherColumn(
        hourSectionTitle = 18.sp,
        dateSectionTitle = 14.sp,
        disclaimer = 10.sp,
        conditionTitle = 18.sp,
        conditionText = 12.sp,
        indexTitleBeforeCard = 12.sp,
        indexTextInsideCard = 10.sp,
        infoMainNow = 12.sp,
        infoMainLater = 10.sp
    )
)

fun createFontSizes(platform: Platform = currentPlatform) = when (platform) {
    Platform.ANDROID -> defaultFontSizes
    Platform.IOS -> defaultFontSizes
    Platform.JVM -> jvmFontSizes
    Platform.JS -> jvmFontSizes
    Platform.LINUX -> jvmFontSizes
    Platform.MACOS -> jvmFontSizes
    Platform.WINDOWS -> jvmFontSizes
}
